import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Delete alerts
 *
 * @private
 */
export const createAlert = createAsyncThunk<
  // Return type of the alertIds creator
  string,
  // First argument to the alertIds creator
  uui.domain.client.gps.wwgps.EventAlert,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/alert/create', async (alert, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/alert/create', {
      category: 'rpc',
      type: 'rpc/alert/create',
      alert,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {createAlert}`,
      { tags: ['rpc', 'alert'], info: alert },
      'error',
    )
    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: 'Create alert failed',
      error,
    })
  }
})
